import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';

@Component({
  selector: 'input-text',
  templateUrl: 'inputText.component.html',
  styleUrls: ['inputText.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true,
    },
  ],
})
export class InputTextComponent extends ControlValueAccessorDirective {
  @Input() placeholder: string = '';
  @Input() public readonly: boolean = false;

  constructor() {
    super();
  }
}
